import { useEffect } from "react";
import Dashboard from "./Dashboard";
import { connect } from "./api.js";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Apps from "./Apps";

function App() {
    useEffect(() => {
        connect();
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/apps" element={<Apps />} />
                {/* temporary */}
                <Route
                    path="/"
                    element={<Navigate to="/dashboard" replace />}
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
